module.exports = __webpack_public_path__ + "media/arrows/arrow--white-88052e73.svg";